import React from 'react';
import { number, object, oneOfType, string, bool } from 'prop-types';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';
import { allPass, has } from 'ramda';
import Typography from '@material-ui/core/Typography';

const MyTypography = ({ align = 'center', content = '', type = 'default', values, ...rest }) => {
  const isIntl = allPass([has(['id']), has(['defaultMessage'])]);

  return (
    <Typography align={align} {...rest}>
      {
        {
          date: <FormattedDate value={content} />,
          time: <FormattedTime value={content} />,
          default: isIntl(content) ? (
            <FormattedMessage {...content} values={{ ...values, br: () => <br /> }} />
          ) : (
            content
          ), // had to set id with a default value to shut a console error.
        }[type]
      }
    </Typography>
  );
};

MyTypography.propTypes = {
  noWrap: bool,
  align: string,
  className: string,
  color: string,
  content: oneOfType([number, object, string]),
  type: string,
  variant: string,
  values: object,
  style: object,
};

export default MyTypography;
